import { axios } from "utils";

import { ADMIN_MODULES_URL as endpoint } from "consts";

import { AllSideCropRecommendationResponse, SideCropRecommendationRequest, SideCropRecommendationResponse } from "models";

export const getAllSideCropRecommendation = async (signal: AbortSignal): Promise<AllSideCropRecommendationResponse> =>
  axios.get(`${endpoint}/side-crop-recommendations`, { signal: signal });

export const updateSideCropRecommendation = async ({
  data,
  signal,
}: {
  data: SideCropRecommendationRequest[];
  signal: AbortSignal;
}): Promise<SideCropRecommendationResponse> => axios.put(`${endpoint}/side-crop-recommendations`, { data, signal });

export const getAllAdminModules = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}`, { data });

export const getAdminModule = async (data: { signal: AbortSignal; id: string }) => axios.get(`${endpoint}/${data.id}`, { data });

export const updateModule = async (data: { signal: AbortSignal; id: string }) => axios.put(`${endpoint}/${data.id}`, { data });

export const generateModulePropertyList = async (data: { signal: AbortSignal }) =>
  axios.post(`${endpoint}/export-properties`, { data }, { responseType: "blob" });

export const processModuleProperties = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/process-properties`, { data });

export const updateAllFootprints = async (data: { signal: AbortSignal }) => axios.put(`${endpoint}/footprints`, { data });

export const getAdminFieldModule = async (data: { signal: AbortSignal; fieldModuleId: string }) =>
  axios.get(`${endpoint}/field-modules/${data.fieldModuleId}`, { data });

// crops

export const getAllCrops = async (data: { signal: AbortSignal; enabled: boolean }) => axios.get(`${endpoint}/crops`, { data });

export const updateCropsBauData = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/crops/bau-entries`, { data });

export const updateCropsYearlyData = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/crops/yearly-entries`, { data });

export const generateCropSheet = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/crop-sheet`, { data, responseType: "blob" });

export const replaceCrop = async (data: { signal: AbortSignal }) => axios.put(`${endpoint}/crop/replace`, { data });

export const getUserCropYieldData = async (data: { signal: AbortSignal; cropId: string; year: number; farmId: string }) =>
  axios.get(`${endpoint}/crop/yield/${data.farmId}/${data.cropId}/${data.year}`, { data });

// fertilizers

export const getAllFertilizers = async (data: { signal: AbortSignal; enabled: boolean }) => axios.get(`${endpoint}/fertilizers`, { data });

export const updateFertilizerBauData = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/fertilizers/bau-entries`, { data });

export const updateFertilizerYearlyData = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/fertilizers/yearly-entries`, { data });

// tillage seedings

export const getAllTillageSeedings = async (data: { signal: AbortSignal; enabled: boolean }) => axios.get(`${endpoint}/tillage-seedings`, { data });

export const updateTillageSeedingBauData = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/tillage-seedings/bau-entries`, { data });

export const updateTillageSeedingYearlyData = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/tillage-seedings/yearly-entries`, { data });

// pesticides

export const updatePesticidesBauData = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/pesticides/bau-entries`, { data });

export const updatePesticidesYearlyData = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/pesticides/yearly-entries`, { data });

// Region sequestration values

export const processRawCropSequestrationData = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/process-raw-sequestration-data`, { data });

export const checkRegionsUploaded = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/region-data`, { data });

export const processRegionData = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/process-region-data`, { data });
